<template>
    <y-row class="mx-0 pt-5 mt-3">
        <y-col
            md="8"
            class="pt-5"
        >
            <slot />
        </y-col>
        <y-col
            md="4"
            class="pt-5"
        >
            <y-invoice
                :invoice-model="invoiceModel"
                :next-hint="nextHint"
                :disable-next="disableNext"
                :button-content="buttonContent"
                @next="$emit('next')"
            />

            <p
                v-if="description"
                class="invoice-description"
            >
                <strong>{{ `${$t('cart.description')}: ` }}</strong>
                <span>{{ description }}</span>
            </p>
        </y-col>
    </y-row>
</template>

<script>
    import { YInvoice } from '@/modules/cart/blocks/Invoice';

    export default {
        name: 'StepWrapper',

        components: {
            YInvoice,
        },

        props: {
            /**
             * Invoice Model
             */
            invoiceModel: {
                type: Object,
            },

            /**
             * A hint for enable next button
             */
            nextHint: {
                type: String,
            },

            /**
             * Disable to go next step
             */
            disableNext: {
                type: Boolean,
            },

            /**
             * A description that show under invoice
             */
            description: {
                type: String,
            },

            /**
             * Next Button Content
             */
            buttonContent: {
                type: String,
            },
        },
    };
</script>
